@switch (state) {
  @case ('enabling') {
    <div class="text-center">
      <h1 class="h5 text-uppercase">{{ 'auth.two-factor.enable.enabling.heading' | translate }}</h1>
      <p class="my-4">{{ 'auth.two-factor.enable.enabling.paragraph' | translate }}</p>
    </div>

    <div class="row">
      <div class="col-12">
        <button
          (click)="enable()"
          class="btn btn-primary w-100"
        >{{ 'auth.two-factor.enable.enabling.activate_btn' | translate }}</button>
      </div>
    </div>
  }
  @case ('confirming') {
    <div class="text-center">
      <h1 class="h5 text-uppercase">{{ 'auth.two-factor.enable.confirming.heading' | translate }}</h1>

      <div class="my-4" [innerHTML]="qrCode"></div>

      <p class="my-4">{{ 'auth.two-factor.enable.confirming.paragraph' | translate }}</p>
    </div>

      <div class="row mt-2">
        <app-form-group
          [formControl]="form.controls.code"
          type="text"
          name="code"
          label="{{ 'auth.two-factor.enable.confirming.form.code.label' | translate }}"
          [errorMessages]="{required: ('auth.two-factor.enable.confirming.form.code.validation_messages.required' | translate)}"
        ></app-form-group>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <button (click)="confirm()" type="submit" class="btn btn-primary w-100">{{ 'auth.two-factor.enable.confirming.form.submit_btn' | translate }}</button>
        </div>
      </div>
  }
}
